import * as proceduralTextures from "procedural-textures/legacy/legacy";
export { proceduralTextures };
export default proceduralTextures;
